(() => {
  const dialog = document.querySelector('[data-qmer-cookie-preferences]');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const status = dialog.querySelector('[role="status"]');
  const fields = [...dialog.querySelectorAll('[data-consent-purpose]')];
  const saves = [...dialog.querySelectorAll('[data-save-consent]')];
  let trigger;
  let privacy;
  let busy = false;

  const showError = () => { status.textContent = status.dataset.error; };
  function loadPrivacy() {
    return new Promise((resolve, reject) => {
      if (window.Shopify?.customerPrivacy?.setTrackingConsent) return resolve(window.Shopify.customerPrivacy);
      if (!window.Shopify?.loadFeatures) return reject(new Error('unavailable'));
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (error || !window.Shopify?.customerPrivacy?.setTrackingConsent) reject(new Error('unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    });
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href$="#shopifyReshowConsentBanner"]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    trigger = link;
    status.textContent = '';
    saves.forEach(button => { button.disabled = true; });
    fields.forEach(field => { field.checked = false; field.disabled = true; });
    dialog.showModal();
    try {
      privacy = await loadPrivacy();
      const current = privacy.currentVisitorConsent();
      fields.forEach(field => { field.checked = current[field.dataset.consentPurpose] === 'yes'; field.disabled = false; });
      saves.forEach(button => { button.disabled = false; });
    } catch { showError(); }
  }, true);

  dialog.querySelector('[data-close-preferences]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => trigger?.focus());
  saves.forEach(button => button.addEventListener('click', () => {
    if (!privacy || busy) return;
    busy = true;
    saves.forEach(item => { item.disabled = true; });
    const selected = Object.fromEntries(fields.map(field => [field.dataset.consentPurpose,
      button.dataset.saveConsent === 'reject' ? false : field.checked]));
    try {
      privacy.setTrackingConsent(selected, result => {
        busy = false;
        saves.forEach(item => { item.disabled = false; });
        if (result?.error) showError();
        else dialog.close();
      });
    } catch {
      busy = false;
      saves.forEach(item => { item.disabled = false; });
      showError();
    }
  }));
})();
